import { fr } from './fr'
import { es } from './es'
import { pt } from './pt'
import { de } from './de'
import { it } from './it'
import { ja } from './ja'
import { ko } from './ko'
import { ar } from './ar'

export { fr, es, pt, de, it, ja, ko, ar }

export const defaultTranslations = {
  // Composer
  'composer.placeholder': 'Type your message...',
  'composer.sendButton.ariaLabel': 'Send Message Button',
  'composer.voiceButton.ariaLabel': 'Voice Input Button',
  'composer.fileButton.ariaLabel': 'Upload File Button',
  'composer.messageInput.ariaLabel': 'Message Input',

  // File attachment
  'fileAttachment.uploadError': 'Upload Error',
  'fileAttachment.fallbackExtension': 'File',
  'fileAttachment.removeButton.ariaLabel': 'Remove File Button',

  // Header
  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': 'Expand Header Button',
  'header.sound.enable': 'Enable chat sounds',
  'header.sound.disable': 'Disable chat sounds',

  // Conversation history
  'conversationHistory.title': 'Conversations',
  'conversationHistory.empty': 'No conversation started yet',
  'conversationHistory.newConversation': 'New conversation',
  'conversationHistory.sentAttachment': 'Sent an attachment',
  'conversationHistory.showButton.ariaLabel': 'Show Recent Conversations Button',

  // Restart conversation modal
  'restartConversation.title': 'Create New Conversation',
  'restartConversation.description': 'This will clear the current conversation and start a new one.',
  'restartConversation.confirm': 'New conversation',
  'restartConversation.cancel': 'Cancel',
  'restartConversation.button.ariaLabel': 'Restart Conversation Button',

  // Close button
  'closeButton.ariaLabel': 'Close Chatbot Button',

  // Feedback modal
  'feedback.title': 'Help us improve',
  'feedback.description': 'Please provide feedback to help us improve.',
  'feedback.confirm': 'Send feedback',
  'feedback.cancel': 'Cancel',
  'feedback.placeholder': 'Let us know what went wrong...',

  // Error states
  'error.configuration': 'Configuration error',
  'error.bot': 'Bot error',
  'error.network': 'Network error',
  'error.disconnected': 'Disconnected',
  'error.unexpected': 'Unexpected error',

  // Dropdown renderer
  'dropdown.placeholder': 'Select...',
} as const satisfies Record<string, string>

export type WebchatTranslations = { [K in keyof typeof defaultTranslations]: string }

const builtInLocales: Record<string, WebchatTranslations> = { fr, es, pt, de, it, ja, ko, ar }

export function detectLocale(language?: string): WebchatTranslations {
  const lang = language ?? (typeof navigator !== 'undefined' ? navigator.language : 'en')
  const prefix = (lang.split('-')[0] ?? 'en').toLowerCase()
  return builtInLocales[prefix] ?? defaultTranslations
}
